import type * as ents from '@attain-apps/entities'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State {
  /** @see {@link Lookup} */
  widgetAliasLookup: State.Lookup<
    ents.core.mosaic.Widget['alias'],
    ents.core.mosaic.Widget['id']
  >
}
export namespace State {
  export const INITIAL: NoMissing<State> = {
    widgetAliasLookup: {},
  }

  /**
   * Maps alias to its corresponding id, enabling lookups and cross-referencing
   * between different identification methods
   */
  export type Lookup<TAlias extends string, TId extends string> = Partial<
    Record<TAlias, TId>
  >
  export namespace Lookup {
    export function put<TAlias extends string, TId extends string>(
      { state, lookupName }: { state: State; lookupName: keyof State },
      { alias, id }: { alias: TAlias; id: TId },
    ): State {
      return {
        ...state,
        [lookupName]: {
          ...state[lookupName],
          [alias]: id,
        },
      }
    }
  }
}
